import root from 'window-or-global';

export const requestAnimationFrame = step => root.requestAnimationFrame(step);
